import React from 'react';
import styled from 'styled-components';


const Inf= styled.div`
    padding:10px;
    background-color: #D7EBEB;
    position:relative;
    top: 200px;
    left: 400px; 
    width: 50%;
 h5{
     text-transform: capitalize;
     text-align: center;
     color: #E6373C;
     font-size:calc(5px + 1.5vw);
 }

 @media screen and (max-width: 700px) {
   
    margin-left: -20em;
    
 }

    `;



function InfoPrivate () {
    
    return (
        <Inf>
         <h5>Denna sida kräver inloggning!</h5>
        </Inf>
    )
}

export default InfoPrivate;